import * as actionTypes from './actionTypes';

export function getLoginPageLogoAction() {
    return {
        type: actionTypes.GET_LOGIN_PAGE_LOGO,
    };
}

export function setLoginPageLogoAction(url) {
    return {
        type: actionTypes.SET_LOGIN_PAGE_LOGO,
        url,
    };
}

export function getIdentityProvidersAction() {
    return {
        type: actionTypes.GET_IDENTITY_PROVIDERS,
    };
}

export function setIdentityProvidersAction(identityProviders) {
    return {
        type: actionTypes.SET_IDENTITY_PROVIDERS,
        identityProviders,
    };
}

export function passwordRecoveryAction(email) {
    return {
        type: actionTypes.RECOVER_PASSWORD,
        email,
    };
}

export function standardLoginAction(credentials) {
    return {
        type: actionTypes.DO_STANDARD_LOGIN,
        credentials,
    };
}

export function ssoLoginAction(identityProvider) {
    return {
        type: actionTypes.DO_SSO_LOGIN,
        identityProvider,
    };
}

export function setSSOLoginErrorMessageAction(loginErrors) {
    return {
        type: actionTypes.SET_SSO_LOGIN_ERROR,
        loginErrors,
    };
}

export function getSSOLoginErrorMessageAction() {
    return {
        type: actionTypes.GET_SSO_LOGIN_ERROR,
    };
}

export function setStandardLoginErrors(loginErrors) {
    return {
        type: actionTypes.SET_STANDARD_LOGIN_ERROR,
        loginErrors,
    };
}

export function setActiveDialogAction(activeDialog) {
    return {
        type: actionTypes.SET_ACTIVE_DIALOG,
        activeDialog,
    };
}
